module.exports = __webpack_public_path__ + "media/img/decorations/workers-img-left-eb27648848d6fbb68f93b974b8d351ac.svg";